import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
    selector: 'la-multi-col-table',
    imports: [CommonModule],
    template: `
    <table>
      <thead>
        <th> </th>
        <th
          *ngFor="let labelValue of data.entries[0]?.value"
          class="fw-b"
          [class.text-end]="alignValues === 'end'"
          >{{ labelValue?.label || '-' }}</th
        >
      </thead>
      <tbody>
        <tr *ngFor="let row of data.entries">
          <td>{{ row.label }}</td>
          <td
            *ngFor="let labelValue of row.value"
            class="fw-b"
            [class.text-end]="alignValues === 'end'"
            >{{ labelValue?.value || '-' }}</td
          >
        </tr>

        <tr *ngIf="data.summaryRow" class="summary-row">
          <td>{{ data.summaryRow.label }}</td>
          <td
            *ngFor="let value of data.summaryRow.value"
            [class.text-end]="alignValues === 'end'"
            >{{ value }}</td
          >
        </tr>
      </tbody>
    </table>
  `,
    styles: [
        `
      table {
        width: 100%;
        border-collapse: collapse;
        page-break-inside: avoid;
      }

      th,
      td {
        text-align: start;
      }

      table tr:first-child {
        border-top: var(--table-border-top);
      }

      table tr:not(:last-child) {
        border-bottom: var(--table-border);
      }

      table th {
        padding: 0 8px;

        &:first-child {
          padding-left: 0;
        }
      }

      table td {
        padding: 8px;
        font-size: 10pt;
        vertical-align: top;

        &:first-child {
          width: 50%;
          padding-left: 0;
        }
      }

      table tr.summary-row {
        background-color: #fff;
        border-top: 2px solid #00aeef;
        font-weight: 700;
      }
    `,
    ]
})
export class MultiColTableComponent {
  @Input() data: {
    entries: {
      label: string;
      value: { label: string; value: string }[];
    }[];
    summaryRow?: { label: string; value: string[] };
  } = {
    entries: [],
  };
  @Input() alignValues: 'start' | 'end' = 'start';
}
